"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicPurchaseServiceV2 = void 0;
var tslib_1 = require("tslib");
var http_client_1 = require("@wix/http-client");
var enums_1 = require("@wix/wix-vod-constants/dist/api-types/enums");
var purchase_1 = require("./purchase");
var url_1 = require("@wix/wix-vod-shared/dist/src/common/constants/url");
var utils_1 = require("@wix/wix-vod-shared/dist/src/widget/vod-player/components/share-buttons/utils");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var open_tab_1 = require("@wix/wix-vod-shared/dist/src/common/utils/open-tab");
var build_url_1 = require("@wix/wix-vod-shared/dist/src/common/utils/url/build-url");
var APIUrls = {
    order: '/cashier/order',
    status: function (order, transaction) {
        return "/cashier/order/".concat(order, "/transaction/").concat(transaction, "/status");
    },
};
var statusesMap = {
    SUCCESS: enums_1.PaymentStatus.ACTIVE,
    APPROVED: enums_1.PaymentStatus.ACTIVE,
    OK: enums_1.PaymentStatus.ACTIVE,
    PENDING: enums_1.PaymentStatus.PENDING,
    PENDING_MERCHANT: enums_1.PaymentStatus.PENDING,
    CANCEL: enums_1.PaymentStatus.CANCELED,
    CANCELED: enums_1.PaymentStatus.CANCELED,
};
var PublicPurchaseServiceV2 = /** @class */ (function (_super) {
    tslib_1.__extends(PublicPurchaseServiceV2, _super);
    function PublicPurchaseServiceV2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.client = new http_client_1.HttpClient({
            baseURL: "".concat(hosts_1.PRODUCTION_HOSTS.paypal, "/vod"),
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
            xsrfCookieName: null,
            xsrfHeaderName: null,
            params: {
                bsi: (0, utils_1.getBsi)(),
            },
        });
        return _this;
    }
    PublicPurchaseServiceV2.prototype.createOrder = function (videoId, channelId, paymentType, siteUrl, instance, compId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.client.post(APIUrls.order, {
                            channelId: channelId,
                            refItemId: videoId,
                            type: paymentType,
                            ref: siteUrl,
                            redirectParams: (_a = {
                                    returnUrl: siteUrl
                                },
                                _a[url_1.URL_PARAM_COMP_ID] = compId,
                                _a[url_1.URL_PARAM_VIDEO_ID] = videoId,
                                _a[url_1.URL_PARAM_PAYMENT_TYPE] = paymentType,
                                _a[url_1.URL_PARAM_STATE] = url_1.URL_STATE_COMPLETE_PURCHASE,
                                _a),
                        }, { params: { instance: instance } })];
                    case 1:
                        data = (_b.sent()).data;
                        return [2 /*return*/, data.order.id];
                }
            });
        });
    };
    PublicPurchaseServiceV2.prototype.getPaymentStatus = function (videoId, channelId, orderId, transactionId, instance, paymentType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var status;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client
                            .get(APIUrls.status(orderId, transactionId), { params: { instance: instance } })
                            .then(function (response) { return ({ status: response.data.status }); }, function (error) { return ({ status: 'ERROR', error: error }); })];
                    case 1:
                        status = (_a.sent()).status;
                        return [2 /*return*/, statusesMap[status]];
                }
            });
        });
    };
    PublicPurchaseServiceV2.prototype.cancelOrder = function (channelId, siteUrl, instance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                (0, open_tab_1.openBlankTab)((0, build_url_1.buildUrl)("".concat(hosts_1.PRODUCTION_HOSTS.paypal, "/vod/pp/subscribe/cancel_profile"), {
                    type: 'subscription',
                    channelId: channelId,
                    ref: siteUrl,
                    instance: instance,
                }));
                return [2 /*return*/];
            });
        });
    };
    return PublicPurchaseServiceV2;
}(purchase_1.PublicPurchaseService));
exports.PublicPurchaseServiceV2 = PublicPurchaseServiceV2;
//# sourceMappingURL=purchase.v2.js.map